import axios from './axiosInstance'

const setDefaults = () => {
  axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencode'
  axios.defaults.headers.common.Accept          = 'application/json'
}

const GetSuperUser = ({ token, uid }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.get(`/superusers/${uid}`)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const GetSuperUsers = ({ token }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.get('/superusers')
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const AddSuperUser = ({ token, superuser }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/superusers/add', superuser)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const SelectSuperUser = ({ token, _id }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.get(`/superusers/select/${_id}`)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const UpdateSuperUser = ({ token, superuser }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/superusers/update/${superuser._id}`, superuser)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

export {
  GetSuperUser,
  GetSuperUsers,
  AddSuperUser,
  SelectSuperUser,
  UpdateSuperUser
}
